import React from "react";
import "./experiences.css";
import { IoIosArrowForward } from "react-icons/io"

const Experiences = () => {
  return (
    <section id="expriences">
      <h5>What Experience I Have</h5>
      <h2>My Experience</h2>

      <div className="container expriences__container">
        <div className="timeline">

          {/* Exprience 1 - left */}
          <div className="timeline__item timeline__item--left">
            <div className="timeline__content">
              <h3>Web Developer Intern</h3>
              <h4>LANAI Simplify Software</h4>
              <p className="timeline__date">April 2024 - May 2024</p>
              <ul className="timeline__tasks">
                <li>
                  <IoIosArrowForward className="timeline__icon" /> Designed and developed
                  a web application for managing end-of-studies internships.
                </li>
                <li>
                  <IoIosArrowForward className="timeline__icon" /> Implemented front-end
                  using Angular (PrimeNG) framework .
                </li>
                <li>
                  <IoIosArrowForward className="timeline__icon" /> Built back-end services
                  with Spring framework.
                </li>
                <li>
                  <IoIosArrowForward className="timeline__icon" /> Participated in full
                  development lifecycle from design to deployment
                </li>
              </ul>
            </div>
          </div>

          {/* Exprience 2 - Right */}
          <div className="timeline__item timeline__item--right">
            <div className="timeline__content">
              <h3>Data & AI Intern</h3>
              <h4>3D Smart Factory</h4>
              <p className="timeline__date">Jul 2025 - Sep 2025</p>
              <ul className="timeline__tasks">
                <li>
                  <IoIosArrowForward className="timeline__icon" /> Built an interactive
                  Streamlit application to generate and analyze synthetic data.
                </li>
                <li>
                  <IoIosArrowForward className="timeline__icon" /> Implemented SDV models
                  including GaussianCopula and CTGAN.
                </li>
                <li>
                  <IoIosArrowForward className="timeline__icon" /> Supported multiple data
                  types: single-table, multi-table, and sequential data.
                </li>
                <li>
                  <IoIosArrowForward className="timeline__icon" /> Parti Created
                  visualizations and evaluation metrics to compare real vs.
                  synthetic data.
                </li>
              </ul>
            </div>
          </div>

        </div>
      </div>
    </section>
  );
};

export default Experiences;
